import React from 'react';
import { InboxOutlined } from '@ant-design/icons';
import { Col, Form, Row, Typography, Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import FormHelper from 'helpers/FormHelper';
import FileList from '../../../../../../../components/fileList/index.';
import { Descriptions } from 'antd';

const ImagesSection = ({
  isEdit,
  singleItem,
  updateInProcess,
  handleDeleteFile,
  isView,
}) => {
  const { t } = useTranslation();

  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>
          {t('Files')}
        </Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Immagine')}>
          <Form.Item
            name='image'
            valuePropName='fileList'
            getValueFromEvent={FormHelper.normFile}
            noStyle
            multiple={false}
          >
            <Upload.Dragger
              multiple={false}
              name='file'
              beforeUpload={FormHelper.beforeUpload}
              disabled={isView}
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
                {t('Click or drag file to this area to upload1')}
                'JPG', 'PNG', 'SVG'
                {t('Click or drag file to this area to upload2')}
              </p>
            </Upload.Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
                  <Descriptions.Item label={`${t('Formati accettati')}:`}>
                  JPG PNG SVG
                  </Descriptions.Item>
                  <Descriptions.Item label={`${t('Dimensione massima')}:`}>
                  5MB
                  </Descriptions.Item>
            </Descriptions>
        </Form.Item>
        <Row>
          <Col span={24}>
            <FileList
              onDelete={handleDeleteFile}
              loading={updateInProcess}
              hideDeleteBtn={isView}
              data={
                singleItem?.allData?.image
                  ? [
                      {
                        file: {
                          url: singleItem?.allData?.image,
                          file_name: singleItem?.allData?.image_name || 'name',
                          id: singleItem?.allData?.image_id || 'id',
                        },
                        image_id: singleItem?.allData?.image_id,
                        param: 'image',
                      },
                    ]
                  : []
              }
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default React.memo(ImagesSection);
